
// Trust.js

import React from "react";
import styled, { keyframes } from "styled-components";
import {
  FiShield,
  FiAward,
  FiHome,
  FiCheckCircle
} from "react-icons/fi";


const fadeUp = keyframes`

from{

opacity:0;
transform:translateY(30px);

}

to{

opacity:1;
transform:translateY(0);

}

`;



const TrustSection = styled.section`

position:relative;

background:

linear-gradient(
180deg,
${({theme})=>theme.colors.bgAccent},
${({theme})=>theme.colors.white}
);


padding:4rem 1.5rem;


border-top:1px solid ${({theme})=>theme.colors.border};

border-bottom:1px solid ${({theme})=>theme.colors.border};


`;



const Container = styled.div`

max-width:1280px;

margin:0 auto;


`;



const Header = styled.div`

text-align:center;

margin-bottom:3rem;


h2{

font-size:clamp(1.8rem,3vw,2.4rem);

font-weight:800;

color:${({theme})=>theme.colors.textDark};

margin-bottom:.8rem;

}


p{

max-width:650px;

margin:auto;

font-size:1rem;

color:${({theme})=>theme.colors.textMuted};

line-height:1.7;

}


`;



const StatsGrid = styled.div`

display:grid;

grid-template-columns:repeat(3,1fr);

gap:1.5rem;


@media(max-width:${({theme})=>theme.breakpoints.tablet}){

grid-template-columns:1fr;

}


`;



const StatCard = styled.div`

position:relative;


display:flex;

align-items:center;


gap:1.25rem;


padding:1.75rem;


background:${({theme})=>theme.colors.white};


border-radius:20px;


border:1px solid ${({theme})=>theme.colors.border};


box-shadow:

0 8px 25px rgba(15,23,42,.06);



transition:${({theme})=>theme.transitions.default};


overflow:hidden;


animation:${fadeUp}.6s ease both;



&::before{

content:"";

position:absolute;

left:0;

top:0;

height:100%;

width:4px;


background:${({theme})=>theme.colors.primary};


transform:scaleY(0);

transition:.3s;

transform-origin:bottom;


}



&:hover{

transform:translateY(-8px);

box-shadow:

0 18px 40px rgba(15,23,42,.12);


}


&:hover::before{

transform:scaleY(1);

}



@media(max-width:${({theme})=>theme.breakpoints.mobile}){


padding:1.4rem;


}


`;



const IconContainer = styled.div`

width:64px;

height:64px;


flex-shrink:0;


display:flex;

align-items:center;

justify-content:center;


border-radius:18px;


background:

linear-gradient(
135deg,
${({theme})=>theme.colors.primaryLight},
${({theme})=>theme.colors.secondaryLight}
);



color:${({theme})=>theme.colors.primary};


font-size:1.8rem;


`;



const TextContainer = styled.div`

display:flex;

flex-direction:column;


`;



const StatTitle = styled.h3`

font-size:1.05rem;


font-weight:800;


line-height:1.35;


color:${({theme})=>theme.colors.textDark};


margin-bottom:.35rem;


`;



const StatSubtitle = styled.p`

font-size:.85rem;


font-weight:500;


line-height:1.5;


color:${({theme})=>theme.colors.textMuted};


`;



const VerifiedBadge = styled.div`

display:flex;

align-items:center;

gap:6px;


margin-top:.7rem;


font-size:.75rem;


font-weight:700;


color:${({theme})=>theme.colors.primary};


`;





export default function Trust(){


const stats=[


{

icon:<FiShield/>,

title:"100% Quality Assurance",

subtitle:"Guaranteed craftsmanship with premium materials"

},


{

icon:<FiAward/>,

title:"Sharjah EDD Registered & Licensed",

subtitle:"Verified License No. 945516"

},


{

icon:<FiHome/>,

title:"Commercial & Residential Specialist",

subtitle:"Complete fit-out solutions across UAE"

}



];



return(


<TrustSection>


<Container>


<Header>


<h2>
Trusted Excellence In Every Project
</h2>


<p>
Delivering reliable plastering and tiling solutions with professional workmanship, quality materials, and UAE standards.
</p>


</Header>



<StatsGrid>


{

stats.map((stat,index)=>(


<StatCard

key={index}

style={{

animationDelay:`${index*0.15}s`

}}

>


<IconContainer>

{stat.icon}

</IconContainer>



<TextContainer>


<StatTitle>

{stat.title}

</StatTitle>


<StatSubtitle>

{stat.subtitle}

</StatSubtitle>



<VerifiedBadge>

<FiCheckCircle/>

Verified Quality

</VerifiedBadge>


</TextContainer>



</StatCard>


))


}



</StatsGrid>


</Container>


</TrustSection>


);


}

